import axios from "axios";
import React, { useEffect, useState } from "react";
import RxnTable from "../../components/RxnTable";
import {
  Button,
  Modal,
  Row,
  Col,
  Table,
  Card,
  ListGroup,
  Form,
} from "react-bootstrap";
import toast from "react-hot-toast";

export default function RxnInReview() {
  const [rxnInReviewList, setRxnInReviewList] = useState({
    columns: [
      {
        label: "User Name",
        field: "username",
      },
      {
        label: "Reaction Name",
        field: "rxnName",
      },
      {
        label: "Reaction SMARTS",
        field: "rxnSmarts",
      },
      {
        label: "Date Submitted",
        field: "dateSubmitted",
      },
      {
        label: "Last Updated",
        field: "lastUpdated",
      },
      {
        label: "Public",
        field: "isPublic",
      },
      {
        label: "Status",
        field: "status",
      },
    ],
    data: [],
  });
  const [rxnInReviewDetail, setRxnInReviewDetail] = useState();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (row) => {
    getRxnInReviewDetail(row.rxnId);
    setShow(true);
  };
  const [comment, setComment] = useState("");

  async function getRxnInReviewList() {
    setLoading(true);
    await axios({
      method: "GET",
      url: "/admin/manage/reaction_in_review",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => {
      setRxnInReviewList({ ...rxnInReviewList, data: res.data });
    });
    setLoading(false);
  }

  function getRxnInReviewDetail(rxnId) {
    axios({
      method: "GET",
      url: `/admin/manage/reaction_in_review/${rxnId}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => {
      console.log(res.data);
      setRxnInReviewDetail(res.data);
    });
  }

  //TODO
  // 1. Admin Should be able to add comment
  // 2. Or Approve User Reaction In-Review

  function handleAdminComment(rxnId) {
    axios({
      method: "POST",
      url: `/admin/manage/reaction_in_review/${rxnId}/comment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      data: { adminComment: comment },
    });
    getRxnInReviewDetail(rxnId);
  }

  function approveReaction(rxnId) {
    axios({
      method: "POST",
      url: `/admin/manage/reaction_in_review/${rxnId}/approve`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then((res) => {
      handleClose();
      getRxnInReviewList();
      toast.success(`${res.data.msg} `);
    });
  }

  function SynthonList({ synthons }) {
    if (!synthons || synthons.length === 0) {
      return <p className="text-center text-muted">No synthons available</p>;
    }

    const displaySynthons = synthons.map((synthon, index) => (
      <Row key={"synthon" + index} className="mb-3">
        <Col>
          <Card>
            <Card.Header>
              {synthon.synName || `Synthon ${index + 1}`}
            </Card.Header>
            <Card.Body>
              <Row>
                <Col>
                  <Card.Title>Inclusion Smarts</Card.Title>
                  <ListGroup variant="flush">
                    {synthon.inSmarts &&
                      synthon.inSmarts.map((insyn, idx) => {
                        return (
                          <ListGroup.Item key={"inSmarts" + idx}>
                            {insyn}
                          </ListGroup.Item>
                        );
                      })}
                    {(!synthon.inSmarts || synthon.inSmarts.length === 0) && (
                      <ListGroup.Item>No inclusion SMARTS</ListGroup.Item>
                    )}
                  </ListGroup>
                </Col>
                <Col>
                  <Card.Title>Exclusion Smarts</Card.Title>
                  <ListGroup variant="flush">
                    {synthon.exSmarts &&
                      synthon.exSmarts.map((exsyn, idx) => {
                        return (
                          <ListGroup.Item key={"exSmarts" + idx}>
                            {exsyn}
                          </ListGroup.Item>
                        );
                      })}
                    {(!synthon.exSmarts || synthon.exSmarts.length === 0) && (
                      <ListGroup.Item>No exclusion SMARTS</ListGroup.Item>
                    )}
                  </ListGroup>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    ));

    return displaySynthons;
  }

  useEffect(() => {
    getRxnInReviewList();
  }, []);

  return (
    <>
      <RxnTable
        striped
        bordered
        hover
        data={rxnInReviewList}
        loading={loading}
        actions={{
          view: true,
          viewLogic: (row) => handleShow(row),
        }}
      />
      <Modal
        size="xl"
        backdrop="static"
        show={show}
        onHide={handleClose}
        onExit={() => getRxnInReviewList()}
      >
        <Modal.Header closeButton>
          <Modal.Title as={"h2"}>Reaction Review Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {rxnInReviewDetail && (
            <>
              <Table striped bordered hover>
                <tbody>
                  <tr>
                    <th>Reaction ID</th>
                    <td>{rxnInReviewDetail.rxnId}</td>
                  </tr>
                  <tr>
                    <th>Reaction Name</th>
                    <td>{rxnInReviewDetail.rxnName}</td>
                  </tr>
                  <tr>
                    <th>Reaction Description</th>
                    <td>{rxnInReviewDetail.rxnDescription}</td>
                  </tr>
                  <tr>
                    <th>Reaction SMARTS</th>
                    <td>{rxnInReviewDetail.rxnSmarts}</td>
                  </tr>
                  <tr>
                    <th>SMARTS Description</th>
                    <td>{rxnInReviewDetail.rxnSmartsDescription}</td>
                  </tr>
                  <tr>
                    <th>Reaction Tags</th>
                    <td>
                      {rxnInReviewDetail.rxnTags &&
                        rxnInReviewDetail.rxnTags.map((tag, index) => (
                          <li key={"list" + index}>
                            {typeof tag === "object"
                              ? tag.label || tag.name || JSON.stringify(tag)
                              : tag}
                          </li>
                        ))}
                    </td>
                  </tr>
                  <tr>
                    <th>Submitted by user</th>
                    <td>{rxnInReviewDetail.username}</td>
                  </tr>
                  <tr>
                    <th>Date Submitted</th>
                    <td>{rxnInReviewDetail.dateSubmitted}</td>
                  </tr>
                  <tr>
                    <th>Last Updated</th>
                    <td>{rxnInReviewDetail.lastUpdated}</td>
                  </tr>
                  <tr>
                    <th>Status</th>
                    <td>{rxnInReviewDetail.status}</td>
                  </tr>
                  <tr>
                    <th>Admin Comment</th>
                    <td>
                      {rxnInReviewDetail.adminComment || "No comments yet"}
                    </td>
                  </tr>
                </tbody>
              </Table>
              <h2 className="centerText pb-3">Synthons</h2>
              <SynthonList synthons={rxnInReviewDetail.synthons} />
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Card className="w-100">
            <Card.Header>
              <h5 className="mb-0">Admin Comments</h5>
            </Card.Header>
            <Card.Body>
              {rxnInReviewDetail?.adminComment ? (
                <div className="alert alert-info">
                  <strong>Current Comment:</strong>
                  <p className="mb-0 mt-2">{rxnInReviewDetail.adminComment}</p>
                </div>
              ) : (
                <p className="text-muted">No admin comments yet.</p>
              )}

              <Form>
                <Form.Group>
                  <Form.Label>
                    <strong>Add/Update Comment:</strong>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter admin comment..."
                    onChange={(e) => setComment(e.target.value)}
                  />
                </Form.Group>
                <div className="d-flex gap-2 mt-3">
                  <Button
                    variant="primary"
                    onClick={() => handleAdminComment(rxnInReviewDetail.rxnId)}
                  >
                    Save Comment
                  </Button>
                  <Button
                    variant="success"
                    onClick={() => approveReaction(rxnInReviewDetail.rxnId)}
                  >
                    Approve Reaction
                  </Button>
                  <Button variant="danger">Reject Reaction</Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
        </Modal.Footer>
      </Modal>
    </>
  );
}
